// Route: /tools/visuals/[id] — LEGACY redirect → /tools/visual-explainer/[id].
//
// Самый критичный из двух редиректов: именно этот адрес сервер кладёт в
// `actionUrl` уведомления «разбор готов» (`inngest/functions/
// generateVisualAnalysis.ts`), и он же лежит в старых письмах и закладках.
// Id не меняется — `params.id` уходит в `params.id` один в один.
//
// `replace: true` — чтобы «назад» не возвращал в петлю редиректа.

import { tolerantSearch } from "@studyhub/shared/utils/tolerant-search";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

const searchSchema = z.object({
	demo: z.enum(["default", "loading", "error", "processing"]).optional(),
});

export const Route = createFileRoute("/tools/visuals/$id")({
	validateSearch: tolerantSearch(searchSchema),
	beforeLoad: ({ params, search }) => {
		throw redirect({
			to: "/tools/visual-explainer/$id",
			params: { id: params.id },
			// Схема цели идентична (`demo`), но переклад явный — см. гейт
			// `routes/__tests__/redirect-search.test.ts`.
			search: search.demo ? { demo: search.demo } : {},
			replace: true,
		});
	},
});
